<style scoped lang="scss">

</style>

<template>
  <div>
    <Head title="Businesses" />
    <h1 class="mb-8 text-3xl font-bold">Business</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
<!--      <table class="w-full whitespace-nowrap">-->
<!--        <tr v-for="business in businesses.data" :key="business.id" class="hover:bg-gray-100 focus-within:bg-gray-100">-->
<!--          <td class="border-t">-->
<!--            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/businesses/${business.id}`">-->
<!--              {{ business }}-->
<!--            </Link>-->
<!--          </td>-->
<!--        <tr v-if="businesses.total === 0">-->
<!--          <td class="px-6 py-4 border-t" colspan="4">No businesses fool! Go make sum</td>-->
<!--        </tr>-->
<!--      </table>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businesses: Object,
  }
}
</script>
